export const GOVERNORATE_OPTIONS = [
  { value: "القاهرة", labelAr: "القاهرة", labelEn: "Cairo" },
  { value: "الجيزة", labelAr: "الجيزة", labelEn: "Giza" },
  { value: "القليوبية", labelAr: "القليوبية", labelEn: "Qalyubia" },
  { value: "الإسكندرية", labelAr: "الإسكندرية", labelEn: "Alexandria" },
  { value: "البحيرة", labelAr: "البحيرة", labelEn: "Beheira" },
  { value: "مطروح", labelAr: "مطروح", labelEn: "Matrouh" },
  { value: "كفر الشيخ", labelAr: "كفر الشيخ", labelEn: "Kafr El Sheikh" },
  { value: "الغربية", labelAr: "الغربية", labelEn: "Gharbia" },
  { value: "المنوفية", labelAr: "المنوفية", labelEn: "Monufia" },
  { value: "الدقهلية", labelAr: "الدقهلية", labelEn: "Dakahlia" },
  { value: "دمياط", labelAr: "دمياط", labelEn: "Damietta" },
  { value: "بورسعيد", labelAr: "بورسعيد", labelEn: "Port Said" },
  { value: "الإسماعيلية", labelAr: "الإسماعيلية", labelEn: "Ismailia" },
  { value: "السويس", labelAr: "السويس", labelEn: "Suez" },
  { value: "الشرقية", labelAr: "الشرقية", labelEn: "Sharqia" },
  { value: "بني سويف", labelAr: "بني سويف", labelEn: "Beni Suef" },
  { value: "الفيوم", labelAr: "الفيوم", labelEn: "Fayoum" },
  { value: "المنيا", labelAr: "المنيا", labelEn: "Minya" },
  { value: "أسيوط", labelAr: "أسيوط", labelEn: "Assiut" },
  { value: "سوهاج", labelAr: "سوهاج", labelEn: "Sohag" },
  { value: "قنا", labelAr: "قنا", labelEn: "Qena" },
  { value: "الأقصر", labelAr: "الأقصر", labelEn: "Luxor" },
  { value: "أسوان", labelAr: "أسوان", labelEn: "Aswan" },
  { value: "البحر الأحمر", labelAr: "البحر الأحمر", labelEn: "Red Sea" },
  { value: "الوادي الجديد", labelAr: "الوادي الجديد", labelEn: "New Valley" },
  { value: "شمال سيناء", labelAr: "شمال سيناء", labelEn: "North Sinai" },
  { value: "جنوب سيناء", labelAr: "جنوب سيناء", labelEn: "South Sinai" }
];

export const EDUCATION_LEVEL_OPTIONS = [
  { value: "الإعدادية", labelAr: "المرحلة الإعدادية", labelEn: "Preparatory Stage" },
  { value: "الثانوية", labelAr: "المرحلة الثانوية", labelEn: "Secondary Stage" },
  { value: "الجامعية", labelAr: "المرحلة الجامعية", labelEn: "University Stage" },
  { value: "خريج", labelAr: "خريج", labelEn: "Graduate" },
  { value: "موظف", labelAr: "موظف", labelEn: "Employed" },
  { value: "لا يعمل", labelAr: "لا يعمل", labelEn: "Not Working" }
];

export const GENDER_OPTIONS = [
  { value: "male", labelAr: "ذكر", labelEn: "Male" },
  { value: "female", labelAr: "أنثى", labelEn: "Female" }
];
